const services = [
  {
    id: "custom-clearance",
    title: "Custom Clearance",
    shortDesc: "Seamless import and export customs handling.",
    description:
      "Our customs clearance services ensure smooth cross-border movement by managing documentation, regulatory compliance, and coordination with customs authorities. We minimize delays and help businesses navigate complex trade regulations efficiently.",
    image: "/assets/services/customs.jpg",
    points: [
      "Import & Export Documentation",
      "Customs Compliance & Advisory",
      "Duty & Tax Coordination",
      "Fast Clearance Processing"
    ]
  },
  {
    id: "transportation",
    title: "Transportation",
    shortDesc: "Reliable domestic and cross-border transportation.",
    description:
      "We offer safe, timely, and cost-effective transportation solutions through a strong carrier network. Our services cover road and multimodal transport with real-time coordination and delivery assurance.",
    image: "/assets/services/transportation.jpg",
    points: [
      "Domestic & Cross-border Transport",
      "Fleet & Carrier Network",
      "Real-time Shipment Coordination",
      "On-time Delivery Assurance"
    ]
  },
  {
    id: "freight-forwarding",
    title: "Freight Forwarding",
    shortDesc: "End-to-end global freight solutions.",
    description:
      "Our freight forwarding services cover air, sea, and land freight, providing optimized routing, cost efficiency, and complete visibility from origin to destination.",
    image: "/assets/services/freight.jpg",
    points: [
      "Air, Sea & Land Freight",
      "End-to-End Shipment Management",
      "Cost & Route Optimization",
      "Global Partner Network"
    ]
  }
];

export default services;
